import fetchClient, { ApiResponse } from '../api-client'
import { CreateUSAPkgLookupPayload, MeestPkgResponse, USAPkgLookupItem } from './types'

/**
 * Find USA package by order number via Meest API (proxied by server).
 * Returns package data or throws if not found (404).
 */
export async function findByOrderNumber(orderNumber: string): Promise<MeestPkgResponse> {
  const res = await fetchClient.get<ApiResponse<MeestPkgResponse>>('/pkg-lookup/find-by-order-number', {
    params: { orderNumber: orderNumber.trim() },
  })
  if (!res.data.data) {
    throw new Error('Package not found')
  }
  return res.data.data
}

/**
 * Create a USA package lookup. Send ownerEmail; server looks up userId and stores it.
 */
export async function createLookup(payload: CreateUSAPkgLookupPayload): Promise<USAPkgLookupItem> {
  const res = await fetchClient.post<ApiResponse<USAPkgLookupItem>>('/pkg-lookup', payload)
  if (!res.data.data) {
    throw new Error('Failed to create lookup')
  }
  return res.data.data
}

/**
 * List all USA package lookups (admin or USA warehouse only).
 */
export async function getUSAPkgLookups(): Promise<USAPkgLookupItem[]> {
  const res = await fetchClient.get<ApiResponse<USAPkgLookupItem[]>>('/pkg-lookup')
  return res.data.data ?? []
}

/**
 * Delete a USA package lookup by id.
 */
export async function deleteUSAPkgLookup(id: string): Promise<void> {
  await fetchClient.delete(`/pkg-lookup/${id}`)
}
